// extracted by mini-css-extract-plugin
module.exports = {"iconPositionInTable":"style_iconPositionInTable__1xoOp","errors":"style_errors__1qPXG","container":"style_container__1J5wN","footerNav":"style_footerNav__1hWJN"};